import { socket } from '../..';
import { agentTestEvents } from '@shared/services/agent-test';

export const handleAgentTestStreamMessage = () => {
  return socket.onMessage('AGENT_TEST_STREAM_MESSAGE', (payload) => {
    agentTestEvents.emitStream(payload);
  });
};
